import * as React from 'react';
import {
    Button, Card,
    CardActions,
    CardContent,
    Container,
    Divider,
    FormControl,
    InputLabel,
    Modal,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from "@mui/material/TextField";
import { DataGrid, GridColDef,GridRenderCellParams  } from '@mui/x-data-grid';
import SideBar from "../../componets/sideBar/sideBar";
import {unwrapResult} from "@reduxjs/toolkit";
import {openNotifier} from "../../store/notifier";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
    IVehicle,
    initialState,
    VehiclesSelector,
    ITypeVehicle,
    IBrandVehicle,
    addVehicle,
    getVehicle,
    updateVehicle,
    resetVehicle,
    startEditLoading,
    finishEditLoading,
    vehicleTypeLoading,
    vehicleBrandLoading,
    getVehicleType,
    getVehicleBrand,
    disabledVehicle,
    listVehicles
} from "../../store/vehicles";
import {useSelector} from "react-redux";
import {AxiosError} from "axios";
import {useAppDispatch} from "../../store/store";
import EditIcon from "@mui/icons-material/Edit";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import CheckIcon from "@mui/icons-material/Check";

interface RowData {
    id: number;
    name: string;
    age: number;
    tipo: string,
    firstName: string,
}



const handleDelete = (id: number): void => {
    console.log('Delete row with id:', id);
    // Implement your delete logic here
};



const AddVehicleSchema = Yup.object().shape({
    idAvailability:Yup.number()
        .required("Estado es requerido")
        .positive('Estado es requerido'),
    idTiposVehiculo:Yup.number()
        .required("Tipo de vehiculo es requerido")
        .positive('Tipo de vehiculo es requerido'),
    strPlaca:  Yup.string()
        .required("Numero de placa es requerido")
        .min(2, "Por favor, ingresa más caracteres.")
        .max(50, "Por favor, reduce el número de caracteres."),
    idMarca:Yup.number().required("Marca es requerido")
        .required("Marca es requerido")
        .positive('Marca es requerida'),
    strModelo:Yup.string().required("Modelo es requerido")
        .min(2, "Por favor, ingresa más caracteres.")
        .max(60, "Por favor, reduce el número de caracteres."),
    strEconomico:Yup.string().required("Inventario es requerido")
        .min(2, "Por favor, ingresa más caracteres.")
        .max(60, "Por favor, reduce el número de caracteres."),
    strMotor:Yup.string().required("Motor es requerido")
        .min(2, "Por favor, ingresa más caracteres.")
        .max(60, "Por favor, reduce el número de caracteres."),
    strSerie:Yup.string().required("Serie es requerido")
        .min(2, "Por favor, ingresa más caracteres.")
        .max(60, "Por favor, reduce el número de caracteres."),


});
function Agregar() {
    const [open, setOpen] = React.useState(false);
    const [IdVehiculo, setIdVehiculo] = React.useState(0);
    const dispatch = useAppDispatch();
    const handleOpen = () => {
        setOpen(true)

    };

    const {vehicle,vehicles,typeVehicles,brandVehicles,loading,availabilityVehicles,loadingEdit,
        meta: {
            current_page,
            per_page,
            total
        },

    } = useSelector(VehiclesSelector);

    const columns: GridColDef[] = [
        { field: 'strName', headerName: 'Nombre', width: 150},
        { field: 'strTipoVehiculo', headerName: 'Tipo', width: 130 },
        { field: 'strEconomico', headerName: 'No. Económico', width: 180,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    {params?.row.strEconomico || 'Sin N/E'}
                </>
            )
        },
        {
            field: 'age',
            headerName: 'Disponibilidad',
            type: 'number',
            width: 130,
            renderCell: (params: GridRenderCellParams) => (
               <>
                   {(params?.row?.idAvailability===1)&&(params?.row?.intEstado===1)?'Operable':'No Operable'}
               </>
            )

        },
        {
            field: 'strUsuarioAct',
            headerName: 'Actualizó',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 180,
        },
        {
            field: 'actions',
            headerName: '',
            flex: 1,
            sortable: false,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        className="btnEdit"
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() =>{
                            dispatch(getVehicle({id:params?.row?.idVehiculo})).then(unwrapResult).then((result: any) => {
                                handleOpen();
                                dispatch(startEditLoading())
                            }).catch((result: AxiosError) => {
                                // @ts-ignore
                                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                            })


                        }}
                    >
                        <EditIcon style={{marginRight:5}}/>  Editar
                    </Button>
                    <Button
                        className={`${params?.row?.intEstado ?'btnDeshabilitar':'btnHabilitar'}`}
                        variant="contained"
                        color="secondary"
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() =>{
                            dispatch(disabledVehicle({id:params?.row?.idVehiculo,currentPage:current_page})).then(unwrapResult).then((result: any) => {
                                handleOpen();
                                dispatch(startEditLoading())
                            }).catch((result: AxiosError) => {
                                // @ts-ignore
                                dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                            })
                        }
                        }
                    >
                        {
                            params?.row?.intEstado ?<><DoDisturbIcon style={{marginRight:5}}/> Deshabilitar</>:<><CheckIcon style={{marginRight:5}}/> Habilitar</>
                        }
                    </Button>
                </>
            ),
        },
    ];
    const {
        setFieldValue,
        errors,
        touched,
        submitForm,
        values,
        setValues,
    } = useFormik<IVehicle>({
        initialValues: {
            idAvailability:0,
            idVehiculo:0,
            idTiposVehiculo:0,
            strPlaca:'',
            idMarca:0,
            strModelo:'',
            strEconomico:'',
            strMotor:'',
            strSerie:'',
            txtComentario:''
        },
        validationSchema:AddVehicleSchema,
        onSubmit: (values, {resetForm}) => {


            if(loadingEdit){
                dispatch(updateVehicle({vehicle:values,id:vehicle?.idVehiculo??0})).then(unwrapResult).then((result: any) => {
                    resetForm()
                    dispatch(finishEditLoading())
                    handleClose()
                }).catch((result: AxiosError) => {
                    // @ts-ignore
                    dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                })
            } else {
                dispatch(addVehicle({vehicle:values})).then(unwrapResult).then((result: any) => {
                    resetForm()
                }).catch((result: AxiosError) => {
                    // @ts-ignore
                    dispatch(openNotifier({variant: "error", open: true, message: result?.message}))
                })
            }



        },
    })
    const handleClose = () => {
        setOpen(false)
        dispatch(resetVehicle())
        dispatch(finishEditLoading())
        setValues({
            idAvailability:initialState.vehicle.idAvailability,
            idTiposVehiculo:initialState.vehicle.idTiposVehiculo,
            idVehiculo:initialState.vehicle.idVehiculo,
            strPlaca:initialState.vehicle.strPlaca,
            idMarca:initialState.vehicle.idMarca,
            strModelo:initialState.vehicle.strModelo,
            strEconomico:initialState.vehicle.strEconomico,
            strMotor:initialState.vehicle.strMotor,
            strSerie:initialState.vehicle.strSerie,
            txtComentario:initialState.vehicle.txtComentario,

        })
    };

    React.useEffect(() => {
        if (vehicle?.idVehiculo) {

            setValues({
                idAvailability:vehicle.idAvailability,
                idVehiculo:vehicle.idVehiculo,
                idTiposVehiculo:vehicle.idTiposVehiculo,
                strPlaca:vehicle.strPlaca,
                idMarca:vehicle.idMarca,
                strModelo:vehicle.strModelo,
                strEconomico:vehicle.strEconomico,
                strMotor:vehicle.strMotor,
                strSerie:vehicle.strSerie,
                txtComentario:vehicle.txtComentario,

            })
        }
    }, [vehicle]);

    React.useEffect(() => {

        if (typeVehicles.length<=0) {
            dispatch(getVehicleType({}))

        }
    }, []);
    React.useEffect(() => {
        if (brandVehicles.length<=0) {
            dispatch(getVehicleBrand({}))
        }
    }, []);
    React.useEffect(() => {

        dispatch(listVehicles({page: 1, items: 10}))
    }, []);

    React.useEffect(() => {

    }, [values]);


    return (
        <>

            <Container maxWidth="xl" className="contLayout mt-30">
                <Typography variant="h1" className="titleBody txt-dark" gutterBottom>Agregar Vehiculos</Typography>
                <Typography variant="h2" className="subtitleBody txt-green" gutterBottom>Filtrar por:</Typography>
                <div className="pageAgregar mt-30">
                    <SideBar></SideBar>
                    <div style={{marginBottom:45}}>
                        {
                            (loadingEdit) ? <></>: <>
                                <div className="cont-form-add-vehiculo">

                                    <div>
                                        <FormControl fullWidth error={!!errors.idTiposVehiculo && !!touched.idTiposVehiculo}>
                                            <InputLabel id="label-type-vehicle">Tipo de Vehículo</InputLabel>
                                            <Select
                                                labelId="label-type-vehicle"
                                                id="idvehiculostipo"
                                                value={values.idTiposVehiculo}
                                                label="Tipo de Vehículo"
                                                onChange={(event, child)=>{
                                                    setFieldValue("idTiposVehiculo", event.target.value??1)
                                                }}
                                            >
                                                <MenuItem value={0}></MenuItem>
                                                {
                                                    typeVehicles.filter(Boolean).map((typeVehicle:ITypeVehicle)=>
                                                        <MenuItem value={typeVehicle.id}  key={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl fullWidth error={!!errors.idMarca && !!touched.idMarca}>
                                            <InputLabel id="demo-simple-select-label">Marca del Vehículo</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="strMarca"
                                                value={values.idMarca}
                                                label="Marca del Vehiculo"
                                                onChange={(event, child)=>{
                                                    setFieldValue("idMarca", event.target.value??1)
                                                }}
                                            >
                                                <MenuItem value={0}></MenuItem>
                                                {
                                                    brandVehicles.filter(Boolean).map((typeVehicle:IBrandVehicle)=>
                                                        <MenuItem value={typeVehicle.id} key={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <TextField
                                            fullWidth
                                            id="strModelo"
                                            value={values.strModelo}
                                            error={!!errors.strModelo && !!touched.strModelo}
                                            helperText={(errors.strModelo && touched.strModelo)?'':''}
                                            label="Modelo del Vehículo"
                                            onChange={(event)=>{
                                                setFieldValue("strModelo", event.currentTarget.value??'')
                                            }}
                                            variant="outlined" />
                                    </div>
                                    <div>
                                        <TextField fullWidth
                                                   id="strMotor"
                                                   value={values.strMotor}
                                                   error={!!errors.strMotor && !!touched.strMotor}
                                                   helperText={(errors.strMotor && touched.strMotor)?'':''}
                                                   onChange={(event)=>{
                                                       setFieldValue("strMotor", event.currentTarget.value??'')
                                                   }}
                                                   label="Motor del Vehículo" variant="outlined" />
                                    </div>
                                </div>
                                <div className="cont-form-add-vehiculo">
                                    <div>
                                        <TextField fullWidth
                                                   id="strSerie"
                                                   label="Número de Serie"
                                                   value={values.strSerie}
                                                   error={!!errors.strSerie && !!touched.strSerie}
                                                   helperText={(errors.strSerie && touched.strSerie)?'':''}
                                                   onChange={(event)=>{
                                                       setFieldValue("strSerie", event.currentTarget.value??'')
                                                   }}
                                                   variant="outlined" />
                                    </div>
                                    <div>
                                        <TextField fullWidth
                                                   id="strNum_placa"
                                                   label="Número de Placa"
                                                   value={values.strPlaca}
                                                   error={!!errors.strPlaca && !!touched.strPlaca}
                                                   helperText={(errors.strPlaca && touched.strPlaca)?'':''}
                                                   onChange={(event)=>{
                                                       setFieldValue("strPlaca", event.currentTarget.value??'')
                                                   }}
                                                   variant="outlined" />
                                    </div>
                                    <div>
                                        <TextField fullWidth
                                                   id="strInventario"
                                                   label="Número Económico"
                                                   value={values.strEconomico}
                                                   error={!!errors.strEconomico && !!touched.strEconomico}
                                                   helperText={(errors.strEconomico && touched.strEconomico)?'':''}
                                                   onChange={(event)=>{
                                                       setFieldValue("strEconomico", event.currentTarget.value??'')
                                                   }}
                                                   variant="outlined" />
                                    </div>
                                    <div>
                                        <FormControl fullWidth error={!!errors.idAvailability && !!touched.idAvailability}>
                                            <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="idAvailability"
                                                value={values.idAvailability}
                                                label="Estado"
                                                onChange={(event, child)=>{
                                                    setFieldValue("idAvailability", event.target.value??1)
                                                }}
                                            >
                                                {/*<MenuItem value={0}></MenuItem>*/}
                                                {
                                                    availabilityVehicles.filter(Boolean).map((typeVehicle:IBrandVehicle)=>
                                                        <MenuItem value={typeVehicle.id} key={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div>
                                        <TextField
                                            id="txtComentario"
                                            label="Comentario"
                                            multiline
                                            value={values.txtComentario}
                                            error={!!errors.txtComentario && !!touched.txtComentario}
                                            helperText={(errors.txtComentario && touched.txtComentario)?'':''}
                                            onChange={(event)=>{
                                                setFieldValue("txtComentario", event.target.value??'')
                                            }}
                                            rows={4}
                                            fullWidth
                                        />
                                    </div>
                                    <div><Button className="btn-full" onClick={()=>submitForm().then( )} >Agregar</Button></div>

                                </div>
                                <Divider className="divider"/>
                            </>
                        }



                        <div className="cont-vehiculos-registrados mt-30">
                            <Typography variant="h3" className="subtitleBody txt-dark" gutterBottom>Vehículos Registrados</Typography>

                            <DataGrid
                                className="tbl-vehiculos mt-20"
                                rows={vehicles}
                                columns={columns}
                                getRowId={(row) => row.idVehiculo}
                                initialState={{
                                    pagination: {
                                        paginationModel: { page: 0, pageSize: 5 },
                                    },
                                }}
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector

                                sortingMode={'client'}
                                filterMode={'server'}
                                paginationMode={'server'}
                                rowCount={total}
                                loading={loading}
                                pageSizeOptions={[5, 10]}
                                onPaginationModelChange={(model, details)=>{

                                    if (current_page !== model.page + 1) dispatch(listVehicles({
                                        page: (model.page + 1),
                                        items: model.pageSize
                                    }));
                                }}


                            />
                        </div>
                    </div>
                </div>
            </Container>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Card className="contModal">
                    <CardContent className="contModalEdit">
                        <Typography variant="h3" className="subtitleBody txt-dark" gutterBottom>Editar Vehiculo</Typography>
                        <div className="mt-30 contFormModalAgregar">
                            <div>
                                <FormControl fullWidth error={!!errors.idTiposVehiculo && !!touched.idTiposVehiculo} >
                                    <InputLabel id="demo-simple-select-label">Tipo de Vehículo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={values.idTiposVehiculo}
                                        label="Tipo de Vehículo"
                                        onChange={(event, child)=>{
                                            setFieldValue("idTiposVehiculo", event.target.value??1)
                                        }}
                                    >
                                        <MenuItem value={0}></MenuItem>
                                        {
                                            typeVehicles.filter(Boolean).map((typeVehicle:ITypeVehicle)=>
                                                <MenuItem value={typeVehicle.id} key={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Marca del Vehículo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={values.idMarca}
                                        label="Marca del Vehiculo"
                                        onChange={(event, child)=>{
                                            setFieldValue("strMarca", event.target.value??1)
                                        }}
                                    >
                                        <MenuItem value={0}></MenuItem>
                                        {
                                            brandVehicles.filter(Boolean).map((typeBrand:IBrandVehicle)=>
                                                <MenuItem value={typeBrand.id} key={typeBrand.id}>{typeBrand.name}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    value={values.strModelo}
                                    error={!!errors.strModelo && !!touched.strModelo}
                                    helperText={(errors.strModelo && touched.strModelo)?'':''}
                                    label="Modelo del Vehículo"
                                    onChange={(event)=>{
                                        setFieldValue("strModelo", event.currentTarget.value??'')
                                    }}
                                    variant="outlined" />
                            </div>
                            <div>
                                <TextField fullWidth id="outlined-basic"
                                           value={values.strMotor}
                                           error={!!errors.strMotor && !!touched.strMotor}
                                           helperText={(errors.strMotor && touched.strMotor)?'':''}
                                           onChange={(event)=>{
                                               setFieldValue("strMotor", event.currentTarget.value??'')
                                           }}
                                           label="Motor del Vehículo" variant="outlined" />
                            </div>
                            <div>
                                <TextField fullWidth id="outlined-basic" label="Número de Serie"
                                           value={values.strSerie}
                                           error={!!errors.strSerie && !!touched.strSerie}
                                           helperText={(errors.strSerie && touched.strSerie)?'':''}
                                           onChange={(event)=>{
                                               setFieldValue("strSerie", event.currentTarget.value??'')
                                           }}
                                           variant="outlined" />
                            </div>
                            <div>
                                <TextField fullWidth id="outlined-basic" label="Número de Placa"
                                           value={values.strPlaca}
                                           error={!!errors.strPlaca && !!touched.strPlaca}
                                           helperText={(errors.strPlaca && touched.strPlaca)?'':''}
                                           onChange={(event)=>{
                                               setFieldValue("strPlaca", event.currentTarget.value??'')
                                           }}
                                           variant="outlined" />
                            </div>
                            <div>
                                <TextField fullWidth id="outlined-basic" label="Número Económico"
                                           value={values.strEconomico}
                                           error={!!errors.strEconomico && !!touched.strEconomico}
                                           helperText={(errors.strEconomico && touched.strEconomico)?'':''}
                                           onChange={(event)=>{
                                               setFieldValue("strEconomico", event.currentTarget.value??'')
                                           }}
                                           variant="outlined" />
                            </div>
                            <div>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={values.idAvailability}
                                        label="Estado"
                                        onChange={(event, child)=>{
                                            setFieldValue("idAvailability", event.target.value??1)
                                        }}
                                    >
                                        {/*<MenuItem value={0}></MenuItem>*/}
                                        {
                                            availabilityVehicles.filter(Boolean).map((typeVehicle:IBrandVehicle)=>
                                                <MenuItem value={typeVehicle.id}>{typeVehicle.name}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                            <TextField
                                id="outlined-multiline-static"
                                label="Comentario"
                                multiline
                                rows={4}
                                onChange={(event)=>{
                                    setFieldValue("txtComentario", event.target.value??'')
                                }}
                                fullWidth
                            />
                            </div>
                        </div>
                    </CardContent>
                    <CardActions style={{marginRight:10,justifyContent:'end'}} className="contBTNModal">
                        <Button className="btn-ghost" size="small" onClick={handleClose} style={{width:'150px'}}>Cancelar</Button>
                        <Button className="btn-full" size="small" style={{width:150}}
                        onClick={()=>{
                            submitForm().then()
                        }}
                        >Guardar</Button>
                    </CardActions>
                </Card>
            </Modal>
        </>
    );
}

export default Agregar;
